var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import RouterModule from '../router';
import { BaseModule } from './../commons/BaseModule';
import Home from './components/Home.vue';
var HomeModule = (function (_super) {
    __extends(HomeModule, _super);
    function HomeModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HomeModule.prototype.preInstall = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.installRoutes(options);
            resolve(true);
        });
    };
    HomeModule.prototype.finalizeInstall = function (options) {
        return new Promise(function (resolve, reject) {
            resolve(true);
        });
    };
    HomeModule.prototype.installRoutes = function (options) {
        var routerModule = options.appModule.getModuleByType(RouterModule);
        var complexRoutes = routerModule.complexRoutes;
        if (process.env.RECIPIENT_ADMIN) {
            complexRoutes.addRawRouteAt('', {
                path: '',
                name: 'home',
                component: Home,
                props: true,
                meta: {
                    isRoot: true
                }
            });
        }
        if (process.env.RECIPIENT_PUBLIC_PROFILE) {
            complexRoutes.addRawRouteAt('', {
                path: '',
                name: 'home',
                component: Home,
                props: true,
                meta: {
                    isRoot: true
                }
            });
        }
    };
    return HomeModule;
}(BaseModule));
export default HomeModule;



//////////////////
// WEBPACK FOOTER
// ./src/modules/home/index.ts
// module id = null
// module chunks = 